import { render, staticRenderFns } from "./NoResultsAvailable.vue?vue&type=template&id=54e384f4&scoped=true&"
import script from "./NoResultsAvailable.vue?vue&type=script&lang=js&"
export * from "./NoResultsAvailable.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsAvailable.vue?vue&type=style&index=0&id=54e384f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e384f4",
  null
  
)

export default component.exports